import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import ViewFilter from './view/ViewFilter'
import CategoriesFilter from './category/CategoriesFilter'
import LocationsFilter from './location/LocationsFilter'
import DatePickerRange from './datepicker/DatePickerRange'
import FiltersStatusBar from './FiltersStatusBar'
import labels from '../../configuration/labels'
import views from '../../configuration/views'
import {
  enableCategoriesFilter,
  enableDateFilter,
  enableLocationsFilter,
  enableViewFilter,
} from '../../configuration/configs'

import '../../styles/scss/components/filters/event-filters-bar.scss'

const EventsFiltersBar = () => {
  const currentView = useSelector((state) => state.filtersData.view)
  const [rangeLabel, setRangeLabel] = useState(labels.filteredEventsDate)
  const isCalendarView = currentView === views.monthly

  return (
    <div className="decoupled-events__events-filters-bar">
      <div className="decoupled-events__filters-bar-container">
        <h1>{labels.filteredEventsTitle}</h1>
        <div
          className={`decoupled-events__filters-bar ${isCalendarView ? 'calendar-view' : 'grid-view'}`}
        >
          {enableLocationsFilter && <LocationsFilter />}
          {enableDateFilter && currentView !== views.monthly && (
            <DatePickerRange rangeLabel={rangeLabel} setRangeLabel={setRangeLabel} />
          )}
          {enableCategoriesFilter && <CategoriesFilter />}
          {enableViewFilter && <ViewFilter />}
        </div>
      </div>
      <FiltersStatusBar setRangeLabel={setRangeLabel} />
    </div>
  )
}

export default EventsFiltersBar
